import { render, staticRenderFns } from "./BizCards.vue?vue&type=template&id=5a26063c&scoped=true&"
import script from "./BizCards.vue?vue&type=script&lang=js&"
export * from "./BizCards.vue?vue&type=script&lang=js&"
import style0 from "./BizCards.vue?vue&type=style&index=0&id=5a26063c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a26063c",
  null
  
)

component.options.__file = "BizCards.vue"
export default component.exports